function initQtdProductsInStock() {
  const wrapper = document.querySelector(".product__inventory");
  const stockElement = document.querySelector(".product__inventory-number");
  const stockBar = document.querySelector(".product__inventory-bar-thumb");

  if (!wrapper || !stockElement || !stockBar) return;

  // Configurações vindas do HTML
  const stockMaxDynamic = parseInt(stockElement.dataset.stockLeft, 10);
  const reduceIntervalSec = parseInt(stockElement.dataset.reduce, 10);

  const realStock = parseInt(stockElement.dataset.realStock, 10);
  const realStockVisualMax = parseInt(stockElement.dataset.realStockMax, 10);

  const useRealStock = stockElement.dataset.useRealStock === "true";
  const dynamicMin = parseInt(stockElement.dataset.dynamicMin, 10) || 1;

  const threshold = parseInt(wrapper.dataset.realStockThreshold, 10);

  const reduceIntervalMs = reduceIntervalSec * 1000;

  // Controle de visibilidade do módulo
  if (useRealStock && !isNaN(realStock)) {
    if (realStock > threshold) {
      wrapper.style.display = "none";
      return;
    }
  }

  let stockLeft;
  let baseStock;

  // Define modo de funcionamento
  if (useRealStock && realStock > 0) {
    stockLeft = realStock;
    baseStock = realStockVisualMax || realStock;
  } else {
    stockLeft = Math.floor(Math.random() * (stockMaxDynamic - dynamicMin)) + dynamicMin + 1;
    baseStock = stockMaxDynamic;
  }

  stockElement.textContent = stockLeft;

  // Atualiza barra visual
  function updateBar() {
    const percentage = Math.max(0, Math.min(100, (stockLeft / baseStock) * 100));
    stockBar.style.width = percentage + "%";
  }

  updateBar();

  // Redução automática apenas no modo dinâmico
  function updateStock() {
    if (!(useRealStock && realStock > 0)) {
      if (stockLeft > dynamicMin) {
        stockLeft--;
        stockElement.textContent = stockLeft;
        updateBar();
      }
    }
  }

  setInterval(updateStock, reduceIntervalMs);
}

initQtdProductsInStock();
